export const MODAL_TYPE_RESULT = {
  consentSave: 'consent:save',
  consentChanged: 'consent:changed',
}



// WEBPACK FOOTER //
// ./src/modules/shared/const/modal.const.js